<template>
  <div class="routerRed">

  </div>
</template>
<script>
export default {
  name:'routerRed',
  data(){
    return {
      
    }
  },
  created(){
    var configStorage = JSON.parse(localStorage.getItem('configStorage'))
    if(configStorage){
      this.config = configStorage
      this.backIndex()
    }else{
      this.$router.push({
        path:'/CConfigSetting',
      })
    }
    
  },
  mounted(){

  },
  methods:{
    //跳转到项目页
    backIndex(){
      var that = this
      var routerList = JSON.parse(localStorage.getItem('routerList'))
      for(var i in routerList){
        if(that.config.type == routerList[i].type){
          if(routerList[i].unmanShow){
            if(that.config.unmanShow == routerList[i].unmanShow){
              // that.$store.state.scrWidth=1080
              that.$router.push({
                path: routerList[i].path
              })
            }
          }else{
            that.$router.push({
              path: routerList[i].path
            })
          }
        }
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/routerRed.vue